import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import classNames from "classnames";
import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";
import styleConstants from "../../styleConstants";

const styles = {
  container: {
    fill: "none",
    stroke: styleConstants.colors.gray6,
    strokeWidth: 2,
    fontSize: "1.25rem"
  }
};

const DownloadIcon = props => (
  <SvgIcon className={classNames(props.classes.container, props.class)}>
    <path d="M23,15.7v4.9c0,1.4-1.1,2.4-2.4,2.4H3.4C2.1,23,1,21.9,1,20.6v-4.9" />
    <polyline points="5.9,9.6 12,15.7 18.1,9.6 " />
    <line x1="12" y1="15.7" x2="12" y2="1" />
  </SvgIcon>
);

DownloadIcon.propTypes = {
  class: PropTypes.string
};

export default withStyles(styles)(DownloadIcon);
